// Experiment 3 : starting point of the React app
import React from 'react'
import { render } from 'react-dom'
// import { BrowserRouter } from 'react-router-dom'   // Exp 3 used BrowserRouter
import App from './App'
import './App.css'

// ----- Exp 3 version (BrowserRouter wrapped the App here) -----
// render(
//   <BrowserRouter>
//     <App />
//   </BrowserRouter>,
//   document.querySelector('#root')
// )

// ----- Exp 9 version: HashRouter is now inside App.js (needed for GitHub Pages) -----
render(<App />, document.querySelector('#root'))
